// src/locales/en/pos.js
export const pos = {
  // Navigation / general
  posTerminal: 'POS Terminal',
  posOrders: 'POS Orders',
  posCustomers: 'POS Customers',
  posSessions: 'Cashier Sessions',
  posSettings: 'POS Settings',
  pointOfSale: 'Point of Sale',

  // Terminal top bar
  session: 'Session',
  sessionOpen: 'Open',
  sessionClosed: 'Closed',
  noSession: 'No Session',
  openSession: 'Open Session',
  closeSession: 'Close Session',
  exitTerminal: 'Exit Terminal',
  saleDate: 'Sale Date',
  saleDateHint: "Sales are added to that day's cashier session until you change the date or reload.",
  noBackdateSessions: 'There are no past cashier sessions in this shop to backdate into.',
  selectSessionDate: 'Select a date with a cashier session',
  selectSession: 'Select cashier session',
  useToday: 'Use Today',
  sessionClosedLabel: 'Closed',
  backdatedTo: 'Backdated to',
  selectCustomer: 'Select Customer',
  cashSales: 'Cash Sales',
  selectWarehouse: 'Select Warehouse',

  // Cart
  cart: 'Cart',
  emptyCart: 'Cart is empty',
  emptyCartHint: 'Search or scan a product to add it to the cart',
  qty: 'Qty',
  unitPrice: 'Unit Price',
  lineDiscount: 'Discount',
  lineTotal: 'Total',
  removeItem: 'Remove item',
  subtotal: 'Subtotal',
  itemDiscount: 'Item Discounts',
  orderDiscount: 'Order Discount',
  tax: 'Tax',
  loyaltyDiscount: 'Loyalty Discount',
  grandTotal: 'Grand Total',

  // Actions
  holdOrder: 'Hold',
  clearCart: 'Clear',
  applyDiscount: 'Discount',
  redeemLoyalty: 'Loyalty',
  charge: 'Charge',
  completeSale: 'Complete Sale',
  printReceipt: 'Print Receipt',
  newSale: 'New Sale',

  // Product search
  searchProducts: 'Search products or scan barcode...',
  noProductsFound: 'No products found',

  // Session gate
  sessionRequired: 'Session Required',
  sessionRequiredMsg: 'This shop requires an open cashier session before processing sales.',
  openingCash: 'Opening Cash',
  openingCashPlaceholder: 'Enter cash in drawer',

  // Payment modal
  payment: 'Payment',
  paymentMethod: 'Payment Method',
  cash: 'Cash',
  card: 'Card',
  bankTransfer: 'Bank Transfer',
  voucher: 'Voucher',
  loyaltyPoints: 'Loyalty Points',
  splitPayment: 'Split Payment',
  addPayment: 'Add Payment',
  amountDue: 'Amount Due',
  amountTendered: 'Amount Tendered',
  cashReceived: 'Cash Received',
  change: 'Change',
  remaining: 'Remaining',
  paymentReference: 'Reference (optional)',
  paymentComplete: 'Sale Complete',
  creditSale: 'Credit Sale',

  // Order discount modal
  applyOrderDiscount: 'Apply Order Discount',
  discountAmount: 'Discount Amount',
  discountPercent: 'Discount %',
  applyFlat: 'Flat Amount',
  applyPercent: 'Percentage',

  // Loyalty modal
  loyaltyBalance: 'Points Balance',
  pointsToRedeem: 'Points to Redeem',
  pointValue: 'Point Value',
  discountPreview: 'Discount',
  minPoints: 'Minimum',
  maxDiscount: 'Max discount',
  redeemPoints: 'Redeem Points',
  removeRedemption: 'Remove Redemption',

  // Hold orders drawer
  holdOrders: 'On Hold Orders',
  noHoldOrders: 'No orders on hold',
  recallOrder: 'Recall',
  holdOrderNote: 'Current cart will be placed on hold',

  // Customer selector
  searchCustomers: 'Search customers by name or phone...',
  newCustomer: 'New Customer',
  noCustomersFound: 'No customers found',
  customerPhone: 'Phone',
  customerEmail: 'Email',
  customerCity: 'City',
  searchCity: 'Search city...',
  loyaltyPointsLabel: 'Loyalty Points',

  // Receipt
  receipt: 'Receipt',
  receiptTitle: 'Sales Receipt',
  orderNumber: 'Order #',
  date: 'Date',
  cashier: 'Cashier',
  customer: 'Customer',
  items: 'Items',
  payments: 'Payments',
  totalPaid: 'Total Paid',
  change: 'Change',
  balanceDue: 'Balance Due',

  // Order list page
  allPosOrders: 'All POS Orders',
  filterByStatus: 'Filter by Status',
  filterByPayment: 'Filter by Payment',
  filterByShop: 'Filter by Shop',
  filterByCashier: 'Filter by Cashier',
  dateFrom: 'From',
  dateTo: 'To',
  searchOrders: 'Search by order number...',
  searchOrdersPlaceholder: 'Search by order #, customer name, phone...',
  filterByCustomer: 'Filter by Customer',

  // Dynamic order status labels — used via t(`pos.status_${order.status}`)
  status_completed:          'Completed',
  status_voided:             'Voided',
  status_on_hold:            'On Hold',
  status_credit:             'Credit',
  status_returned:           'Returned',
  status_partially_returned: 'Partially Returned',

  // Dynamic payment status labels — used via t(`pos.payment_${order.paymentStatus}`)
  payment_paid:    'Paid',
  payment_partial: 'Partial',
  payment_unpaid:  'Unpaid',

  // Payment method keys — used via t(`pos.${paymentMethodKey}`) in receipts
  // cash, card, voucher already defined above; bank_transfer needs the underscore form
  bank_transfer: 'Bank Transfer',
  orderNumberCol: 'Order #',
  customerCol: 'Customer',
  cashierCol: 'Cashier',
  totalCol: 'Total',
  paidCol: 'Paid',
  balanceCol: 'Balance',
  statusCol: 'Status',
  paymentStatusCol: 'Payment',
  actionsCol: 'Actions',
  viewOrder: 'View',
  voidOrder: 'Void',
  processReturn: 'Return',
  recordPayment: 'Record Payment',
  printReceiptAction: 'Print Receipt',

  // Status labels
  statusCompleted: 'Completed',
  statusVoided: 'Voided',
  statusOnHold: 'On Hold',
  statusCredit: 'Credit',
  statusReturned: 'Returned',
  statusPartiallyReturned: 'Partially Returned',
  paymentPaid: 'Paid',
  paymentPartial: 'Partial',
  paymentUnpaid: 'Unpaid',

  // Void
  voidOrderTitle: 'Void Order',
  voidReason: 'Reason for voiding',
  voidReasonPlaceholder: 'Enter reason...',
  confirmVoid: 'Confirm Void',
  voidWarning: 'This action cannot be undone. Stock will be restored.',

  // Return modal
  processReturnTitle: 'Process Return',
  returnItems: 'Items to Return',
  returnQty: 'Return Qty',
  available: 'Available',
  refundAmount: 'Refund Amount',
  refundMethod: 'Refund Method',
  refundCash: 'Cash Refund',
  refundCreditNote: 'Credit Note',
  refundLoyaltyPoints: 'Loyalty Points',
  returnReason: 'Return Reason',
  confirmReturn: 'Confirm Return',
  totalRefund: 'Total Refund',

  // Credit payment
  recordCreditPayment: 'Record Payment',
  outstandingBalance: 'Outstanding Balance',
  amountToPayNow: 'Amount to Pay Now',
  confirmPayment: 'Confirm Payment',

  // Customers page
  allPosCustomers: 'POS Customers',
  addCustomer: 'Add Customer',
  editCustomer: 'Edit Customer',
  importCustomers: 'Import',
  backToCustomers: 'Back to Customers',
  customerName: 'Name',
  customerAddress: 'Address',
  customerNotes: 'Notes',
  customerSecondaryPhone: 'Secondary Phone',
  totalSpend: 'Total Spend',
  viewHistory: 'View History',
  purchaseHistory: 'Purchase History',
  noPurchaseHistory: 'No purchase history',
  activeCustomer: 'Active',
  inactiveCustomer: 'Inactive',

  // Import page
  importStep1Title: 'Download Template',
  importStep1Desc: 'Download the Excel template, fill in your customer data, then upload it below.',
  importStep2Title: 'Upload File',
  importStep3Title: 'Preview & Import',
  downloadTemplate: 'Download Template',
  dropZoneText: 'Drag & drop your file here, or click to browse',
  dropZoneSub: 'Supports .xlsx, .xls, .csv — max 1,000 rows',
  rowsFound: 'rows found',
  previewShowing: 'Showing first {{shown}} of {{total}} rows',
  andMoreRows: '...and {{count}} more rows',
  importing: 'Importing...',
  importNCustomers: 'Import {{count}} Customers',
  importComplete: 'Import Complete',
  importedCustomers: 'Imported',
  skippedRows: 'Skipped',
  importErrors: 'Errors',
  rowLabel: 'Row',
  importAnother: 'Import Another File',

  // Sessions page
  cashierSessions: 'Cashier Sessions',
  openNewSession: 'Open New Session',
  activeSession: 'Active Session',
  noActiveSession: 'No active session',
  closedAt: 'Closed At',
  openedAt: 'Opened At',
  closingCash: 'Closing Cash',
  sessionNotes: 'Notes',
  viewZReport: 'View Z-Report',
  zReport: 'Z-Report',
  zReportTitle: 'End of Session Report',
  totalSales: 'Total Sales',
  salesCount: 'Sales Count',
  paymentBreakdown: 'Payment Breakdown',
  voidSummary: 'Voids',
  returnSummary: 'Returns',
  creditSummary: 'Credit Outstanding',
  cashExpected: 'Cash Expected',
  cashVariance: 'Variance',
  selectCashier: 'Select Cashier',
  createSession: 'Create Session',
  sessionSummary: 'Session Summary',
  closingAmounts: 'Closing Amounts (Enter counted cash per method)',
  totalVariance: 'Total Variance',
  outstandingBalance: 'Outstanding Balance',
  statusOpen: 'Open',
  statusClosed: 'Closed',
  filterByStatus: 'Filter by Status',
  cashierCol: 'Cashier',
  statusCol: 'Status',
  sessionOpen: 'Open',
  sessionClosed: 'Closed',

  // POS Settings page
  posSettingsDesc: 'Configure loyalty programme and receipt layout for your POS shops.',
  loyaltySettings: 'Loyalty Programme',
  enableLoyalty: 'Enable Loyalty Points',
  enableLoyaltyHint: 'Customers earn points on purchases and can redeem them as discounts.',
  pointsPerRupee: 'Points Earned per Rupee',
  pointsPerRupeeHint: 'How many points earned per Rs. 1 spent',
  pointValueRupees: 'Value per Point (Rs.)',
  pointValueHint: 'Rupee value of 1 loyalty point when redeemed',
  minRedeemPoints: 'Minimum Points to Redeem',
  minRedeemHint: 'Minimum points required before a customer can redeem',
  maxRedeemPct: 'Max Redemption (% of order)',
  maxRedeemHint: 'Maximum % of order grand total that can be discounted via points',
  receiptSettings: 'Receipt Settings',
  receiptHeader: 'Receipt Header',
  receiptFooter: 'Receipt Footer',
  receiptHeaderPlaceholder: 'Enter header text (e.g. shop address, thank you message)',
  receiptFooterPlaceholder: 'Enter footer text (e.g. return policy)',
  saveSettings: 'Save Settings',

  // Audit / detail page
  auditHistory: 'Audit History',
  posOrders: 'POS Orders',

  // Errors / validation
  cartEmpty: 'Cart is empty',
  sessionRequiredError: 'Please open a cashier session first',
  insufficientLoyaltyPoints: 'Insufficient loyalty points',
  creditNotAllowed: 'Credit sales are not allowed for this shop or customer',

  // Payment fees display
  paymentFee: 'Fee',
  feeAbsorbed: 'absorbed',
  feeChargedToCustomer: 'to customer',
  totalPaymentFees: 'Total Payment Fees',
  paymentFeesCustomer: 'Fees (Customer)',

  // Receipt share buttons
  shareInvoice: 'Share Invoice',
  sendViaWhatsApp: 'WhatsApp',
  sendViaSms: 'Send SMS',
  sendingInvoice: 'Sending…',
  smsSent: 'SMS Sent',

  // Cost & profit columns (for manage_pos_settings users)
  productCostCol: 'Cost',
  paymentFeesCol: 'Fees',
  profitCol: 'Profit',
  totalProductCost: 'Product Cost',
  grossProfit: 'Gross Profit',
};
